<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
          <lib-page-header page-title="RECEBIMENTO ORÇAMENTÁRIO"
            page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/money7.png">
          </lib-page-header>
        </div>
        <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/recebimentos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" type="submit" class="btn btn-info float-right mr-4"
            style="font-size: 13px">Salvar recebimento</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row mt-4 ml-3">
        <lib-divisor altura="170px" imagem="assets/img/global/date_add.png"></lib-divisor>
        <div class="col-md-11 col-lg-11 col-xl-11">
          <div class="form-row">
            <div class="form-group col-sm-12 col-md-3 col-lg-3 col-xl-2">
              <label for="data_recebimento">Data recebimento<span class="text-danger">*</span></label>
              <p-calendar #InputFocus id="data_recebimento" formControlName="data_recebimento"
                inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true"
                [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }" inputId="data_recebimento">
              </p-calendar>
            </div>
            <div class="form-group col-sm-12 col-md-3 col-lg-3 col-xl-2">
              <label for="guia">Guia n˚<span class="text-danger">*</span></label>
              <input name="guia" autofocus formControlName="guia" type="text" class="form-control" id="guia">
            </div>
            <div class="form-group col-sm-12 col-md-3 col-lg-3 col-xl-2">
              <span *ngIf="entidade.id && entidade.especie === 'REA'" class="badge badge-danger mt-4">ANULAÇÃO DO
                RECEBIMENTO</span>
            </div>
          </div>

          <div class="form-row">
            <div *ngIf="!entidade.id" class="form-group col-12">
              <div class="checkbox checbox-switch switch-danger">
                <label>
                  <input type="checkbox" [(ngModel)]="anulacao" [ngModelOptions]="{standalone: true}" />
                  <span></span>
                  Anulação do recebimento orçamentário
                </label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div *ngIf="anulacao" class="form-group col-sm-12 col-md-3 col-lg-3 col-xl-2">
              <label for="data_referencia">Data Referência<span class="text-danger">*</span></label>
              <p-calendar id="data_referencia" formControlName="data_referencia" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }" inputId="data_referencia">
              </p-calendar>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4 ml-3">
        <lib-divisor altura="180px" imagem="assets/img/global/table_money.png"></lib-divisor>
        <div class="col-md-11 col-lg-11 col-xl-11">
          <div class="form-row">
            <div class="form-group col-md-2 col-lg-2 col-xl-1">
              <label for="ficha_id">Ficha n˚<span class="text-danger">*</span></label>
              <input (blur)="buscarFicha()" type="text" class="form-control font-weight-bold" id="ficha_id"
                [(ngModel)]="fichaId" name="ficha_id" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="form-group col-md-10 col-lg-10 col-xl-11">
              <label for="ficha">Descrição da receita<span class="text-danger">*</span></label>
              <p-autoComplete id="ficha" formControlName="ficha" [field]="fichaAutoComplete.conversor"
                [suggestions]="fichaAutoComplete.lista" (completeMethod)="fichaAutoComplete.filtrar($event)"
                placeholder="Digite descrição da receita" (onSelect)="changeFicha()" (onBlur)="montaHistorico()"
                inputStyleClass="form-control font-weight-bold" minLength="2" [style]="{ width: '100%' }"
                [forceSelection]="true" [autoHighlight]="true">
                <ng-template let-ficha pTemplate="item">
                  {{ficha.receita.codigo}} {{ficha.receita.nome}}
                </ng-template>
              </p-autoComplete>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-2 col-lg-2 col-xl-1">
              <label for="conta_id">Conta n˚<span class="text-danger">*</span></label>
              <input (blur)="buscarConta()" type="text" class="form-control font-weight-bold" id="conta_id"
                [(ngModel)]="contaId" name="conta_id" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="form-group col-md-10 col-lg-10 col-xl-11">
              <label for="conta">Nome da conta bancária<span class="text-danger">*</span></label>
              <p-autoComplete id="conta" formControlName="conta" [field]="contaAutoComplete.conversor"
                [suggestions]="contaAutoComplete.lista" (completeMethod)="contaAutoComplete.filtrar($event)"
                placeholder="Digite o nome da conta" (onSelect)="changeConta()"
                inputStyleClass="form-control font-weight-bold" minLength="2" [style]="{ width: '100%' }"
                [forceSelection]="true" [autoHighlight]="true">
                <ng-template let-conta pTemplate="item">
                  {{conta.numero_conta}} {{conta.banco.nome}} {{conta.nome}}
                </ng-template>
              </p-autoComplete>
            </div>
          </div>          
          <div class="form-row" *ngIf="entidadeForm.get('ficha').value">
            <div class="form-group col-md-2 col-lg-2 col-xl-1">
              <span *ngIf="entidadeForm.get('ficha').value.redutor" class="badge badge-warning">REDUDOR DA
                RECEITA</span>
              <span *ngIf="entidadeForm.get('ficha').value.restituicao" class="badge badge-warning">RESTITUIÇÃO DE
                RECEITA</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4 ml-3">
        <lib-divisor altura="300px" imagem="assets/img/global/coins_in_hand.png"></lib-divisor>
        <div class="col-md-11 col-lg-11 col-xl-11">

          <div class="form-row">
            <div class="form-group col-md-4 col-lg-3 col-xl-3 mb-0 pb-0">
              <label *ngIf="!anulacao" for="valor_recebido">Valor recebido<span class="text-danger">*</span></label>
              <label *ngIf="anulacao" for="valor_recebido">Valor anulado<span class="text-danger">*</span></label>
              <input (blur)="blurValorRecebido()" unmask="true" [imask]="imaskConfig" formControlName="valor_recebido"
                type="text" class="form-control font-weight-bold text-right" id="valor_recebido"
                [ngStyle]="anulacao ? {'color': 'red'} : {'color':'#1e88e5'}">
              <span *ngIf="entidade.id && entidade.retencao" class="badge badge-warning mt-4">RETENÇÃO</span>
            </div>
          </div>
          <div class="row mt-0 pt-0 mb-4" *ngIf="entidadeForm.get('ficha').value">
            <div class="col-12">
              <span *ngIf="entidadeForm.get('ficha').value.ensino > 0" class="badge bg-light text-dark">Aplicação no
                ensino
                {{entidadeForm.get('ficha').value.ensino}}%:
                {{(entidadeForm.get('valor_recebido').value * entidadeForm.get('ficha').value.ensino) / 100 |
                number:'1.2-2'}}</span>

              <span *ngIf="entidadeForm.get('ficha').value.saude > 0" class="badge bg-light text-dark">Aplicação na
                saúde
                {{entidadeForm.get('ficha').value.saude}}%:
                {{(entidadeForm.get('valor_recebido').value * entidadeForm.get('ficha').value.saude) / 100 |
                number:'1.2-2'}}</span>
            </div>
          </div>

          <div class="form-row"
            *ngIf="entidadeForm.get('ficha').value && entidadeForm.get('ficha').value.exigir_credor">
            <div class="form-group col-md-12">
              <label for="credor">Credor</label>
              <p-autoComplete formControlName="favorecido" [field]="favorecidoAutoComplete.conversor"
                [suggestions]="favorecidoAutoComplete.lista" id="credor"
                (completeMethod)="favorecidoAutoComplete.filtrar($event)"
                placeholder="Informe cpf/cnpj ou nome/razão social" inputStyleClass="form-control font-weight-bold"
                minLength="2" [style]="{ width: '100%' }" (onSelect)="favorecidoAutoComplete.atualizar(true)"
                [forceSelection]="true" [autoHighlight]="true" *ngIf="favorecidoAutoComplete">
                <ng-template let-favorecido pTemplate="item">
                  {{favorecido.cpf_cnpj | CPF}} {{favorecido.nome}}
                </ng-template>
              </p-autoComplete>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-3"
              *ngIf="entidadeForm.get('ficha').value && entidadeForm.get('ficha').value.exigir_contrato">
              <label for="contrato">Contrato</label>
              <p-autoComplete formControlName="contrato" [field]="contratoAutoComplete.conversor"
                [suggestions]="contratoAutoComplete.lista" (completeMethod)="contratoAutoComplete.filtrar($event)"
                placeholder="Nº Contrato" inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }"
                (onSelect)="contratoAutoComplete.atualizar(true)" (onBlur)="contratoAutoComplete.atualizar(true)"
                [forceSelection]="true" [autoHighlight]="true" *ngIf="contratoAutoComplete">
                <ng-template let-contrato pTemplate="item">
                  {{contrato.numero}} <span
                    *ngIf="contrato.aditivo !== null && contrato.aditivo > 0 ">{{contrato.aditivo}}</span>
                </ng-template>
              </p-autoComplete>
            </div>
            <div class="form-group col-md-3"
              *ngIf="entidadeForm.get('ficha').value && entidadeForm.get('ficha').value.exigir_convenio">
              <label for="convenio">Convênio</label>
              <p-autoComplete formControlName="convenio" [field]="convenioAutoComplete.conversor"
                [suggestions]="convenioAutoComplete.lista" (completeMethod)="convenioAutoComplete.filtrar($event)"
                inputStyleClass="form-control" minLength="2" [forceSelection]="true" [autoHighlight]="true"
                [style]="{ width: '100%' }" *ngIf="convenioAutoComplete">
                <ng-template let-convenio pTemplate="item">
                  {{convenio.numero}}/{{convenio.ano}}
                </ng-template>
              </p-autoComplete>
            </div>
          </div>

          <div class="form-row mt-4">
            <div class="form-group col-12">
              <label for="historico">Histórico<span class="text-danger">*</span></label>
              <textarea formControlName="historico" class="form-control" id="historico" rows="5"></textarea>
            </div>
          </div>
        </div>
      </div>

    </div>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>